<template>
  <v-card class="rounded-sm" color="primary">
    <v-card-text>
      <v-container>
        <v-form ref="form" v-model="licenciaForm" @submit.prevent="registrarLicencia">
          <v-row>
            <v-col cols="6">
              <BaseInput
                class="ui-form-field"
                v-model="licenciaOficialColectiva.direccion"
                label="Dirección"
                background-color="transparent"
              />
            </v-col>
            <v-col cols="6">
              <BaseInput
                class="ui-form-field"
                v-model="licenciaOficialColectiva.noLicencia"
                label="Numero de Licencia"
                background-color="transparent"
              />
            </v-col>
            <v-col cols="6">
              <BaseInput
                class="ui-form-field"
                v-model="licenciaOficialColectiva.nombreInstancia"
                label="Nombre instancia"
                background-color="transparent"
              />
            </v-col>
            <v-col cols="6">
              <BaseInput
                class="ui-form-field"
                v-model="licenciaOficialColectiva.representanteLegal"
                label="Representante legal"
                background-color="transparent"
              />
            </v-col>
            <v-col cols="6">
              <BaseInput
                class="ui-form-field"
                v-model="licenciaOficialColectiva.rm"
                label="RM"
                background-color="transparent"
              />
            </v-col>
            <v-col cols="6">
              <BaseInput
                class="ui-form-field"
                v-model="licenciaOficialColectiva.titular"
                label="Titular"
                background-color="transparent"
              />
            </v-col>
            <v-col cols="6">
              <BaseInput
                class="ui-form-field"
                v-model="licenciaOficialColectiva.vigencia"
                label="Vigencia"
                background-color="transparent"
              />
            </v-col>
            <v-col cols="6">
              <BaseInput
                class="ui-form-field"
                v-model="licenciaOficialColectiva.zm"
                label="ZM"
                background-color="transparent"
              />
            </v-col>
            <v-col cols="6">
              <BaseInput
                class="ui-form-field"
                v-model="licenciaOficialColectiva.fechaAlta"
                v-mask="'##/##/####'"
                hint="Formato de fecha: DD/MM/YYYY"
                background-color="transparent"
                :rules="[rules.required, rules.fechaValida]"
              >
                <template v-slot:label>Fecha alta <span class="red--text">*</span></template>
              </BaseInput>
            </v-col>
            <v-col cols="6">
              <BaseInput
                class="ui-form-field"
                v-model="licenciaOficialColectiva.fechaTramite"
                v-mask="'##/##/####'"
                hint="Formato de fecha: DD/MM/YYYY"
                background-color="transparent"
                :rules="[rules.required, rules.fechaValida]"
              >
                <template v-slot:label>Fecha trámite <span class="red--text">*</span></template>
              </BaseInput>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions class="justify-center ui-module-actions">
      <TextButton class="ui-module-btn-solid" :loading="loading" @click="registrarLicencia">
        Registrar Licencia
      </TextButton>
    </v-card-actions>
  </v-card>
</template>

<script>
import moment from 'moment'
import BaseInput from '../../../base/BaseInput.vue'
import TextButton from '../../../base/TextButton.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    BaseInput,
    TextButton,
  },
  data() {
    return {
      licenciaForm: false,
      loading: false,
      rules: {
        required: (v) => !!v || 'Campo obligatorio',
        fechaValida: (v) =>
          !v || v.length === 10 ? true : 'Formato de fecha: DD/MM/YYYY',
      },
      licenciaOficialColectiva: {
        direccion: '',
        noLicencia: '',
        nombreInstancia: '',
        representanteLegal: '',
        rm: '',
        titular: '',
        vigencia: '',
        zm: '',
        fechaAlta: '',
        fechaTramite: '',
      },
    }
  },
  methods: {
    ...mapActions('licenciaOficialColectiva', ['saveLoc']),
    ...mapActions('licenciaOficialColectiva', {
      fetchLocs: 'fetchLocs',
    }),
    limpiarFormulario() {
      this.licenciaOficialColectiva = {
        direccion: '',
        noLicencia: '',
        nombreInstancia: '',
        representanteLegal: '',
        rm: '',
        titular: '',
        vigencia: '',
        zm: '',
        fechaAlta: '',
        fechaTramite: '',
      }
      this.$refs.form && this.$refs.form.resetValidation()
    },
    async registrarLicencia() {
      const valid = await this.$refs.form.validate()
      if (!valid) return
      this.loading = true
      try {
        const payload = {
          ...this.licenciaOficialColectiva,
          fechaAlta: this.licenciaOficialColectiva.fechaAlta
            ? moment(this.licenciaOficialColectiva.fechaAlta, 'DD/MM/YYYY').format('DD/MM/YYYY')
            : '',
          fechaTramite: this.licenciaOficialColectiva.fechaTramite
            ? moment(this.licenciaOficialColectiva.fechaTramite, 'DD/MM/YYYY').format('DD/MM/YYYY')
            : '',
        }
        await this.saveLoc({ loc: payload })
        this.limpiarFormulario()
        await this.fetchLocs()
        this.$emit('close')
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(108, 92, 231, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(108, 92, 231, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .ui-form-field .v-messages__message {
  color: rgba(224, 224, 224, 0.55) !important;
}

::v-deep .ui-form-field.error--text .v-messages__message {
  color: #ff5252 !important;
}

::v-deep .ui-form-field.error--text .v-input__slot {
  border-color: #ff5252 !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label {
  color: #a29bfe !important;
}

::v-deep .ui-module-actions .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s ease;
}

::v-deep .ui-module-actions .v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(108, 92, 231, 0.3);
}
</style>
